function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.6 4.79999C0.716 4.79999 0 5.51599 0 6.39999V17.6C0 18.484 0.716 19.2 1.6 19.2H15.2C16.084 19.2 16.8 18.484 16.8 17.6V6.39999C16.8 5.51599 16.084 4.79999 15.2 4.79999H1.6ZM23.2 6.39999C22.9917 6.39999 22.7915 6.48127 22.6422 6.62655L18.4 10.4V12V13.6L22.6594 17.3891L22.6719 17.4C22.8178 17.5286 23.0055 17.5997 23.2 17.6C23.4122 17.6 23.6157 17.5157 23.7657 17.3657C23.9157 17.2156 24 17.0122 24 16.8V12V7.19999C24 6.98781 23.9157 6.78433 23.7657 6.6343C23.6157 6.48427 23.4122 6.39999 23.2 6.39999Z",
  fill: "#342B75"
});

var SvgVideocall = function SvgVideocall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideocall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videocall.b69a1c00.svg";
export { ForwardRef as ReactComponent };